<template>
  <hm-content title="">
    <div class="mb10">
      <el-radio-group
        v-model="searchConditions.querySnType"
        size="small"
        @change="switchTab"
      >
        <el-radio-button label="wait">待处理</el-radio-button>
        <el-radio-button label="do">已补写</el-radio-button>
        <el-radio-button label="ignore">已忽略</el-radio-button>
      </el-radio-group>
    </div>

    <div v-if="storeCode === '42010216070190' || storeCode === '53010017032439' " class="mb10">
      <el-button class="mr10" type="primary" size="small" @click="writeDialog('order')">批量写入订单</el-button>
      <el-button class="mr10" type="primary" size="small" @click="writeDialog('updateGoodsSn')">批量修改订单货号写入</el-button>
      <el-button class="mr10" type="primary" size="small" @click="writeDialog('updateShopId')">批量修改订单门店写入</el-button>
      <el-button class="mr10" type="primary" size="small" @click="writeDialog('ignore')" v-if="searchConditions.querySnType == 'wait'">批量忽略订单</el-button>
    </div>

    <div class="table-panel flex flex-end">
      <el-select
        clearable
        v-model="searchConditions.orderType"
        placeholder="请选择订单类型"
        size="small"
        filterable
        class="mr10"
      >
        <el-option label="砍价订单" value="kjdd"></el-option>
        <el-option label="拼团订单" value="ptdd"></el-option>
        <el-option label="秒杀订单" value="mshd"></el-option>
        <el-option label="微店订单" value="wshop"></el-option>
        <el-option label="兑换订单" value="dhdd"></el-option>
        <el-option label="代客下单-当面付" value="smg_faceToFace"></el-option>
        <el-option label="代客下单-网推" value="smg_netPush"></el-option>
        <el-option label="积分兑换订单" value="integral_order"></el-option>
        <el-option label="专享订单" value="exclusive_order"></el-option>
        <el-option label="组合套餐" value="combination_set_order"></el-option>
        <el-option label="接龙订单" value="jielong_order"></el-option>
      </el-select>
      <el-date-picker
        size="small"
        clearable
        class="mr10"
        v-model="searchConditions.date"
        ref="datepicker"
        value-format="yyyy-MM-dd HH:mm:ss"
        :default-time="['00:00:00', '23:59:59']"
        type="datetimerange"
        range-separator="至"
        start-placeholder="销售开始日期"
        end-placeholder="销售结束日期"
      ></el-date-picker>
      <el-input
        clearable
        v-model.trim="searchConditions.receiptSn"
        placeholder="输入订单号"
        size="small"
        class="ipt mr10"
        style="width:200px"
      ></el-input>
      <el-input
        type="number"
        clearable
        v-model.trim="searchConditions.memberMobile"
        placeholder="输入会员手机号"
        size="small"
        class="ipt mr10"
      ></el-input>
      <el-select
          clearable
          size="small"
          filterable
          class="mr10"
          v-model="searchConditions.belongShopId"
          placeholder="请选择发货门店"
      >
        <el-option
            v-for="(item, i) in shopList"
            :key="i"
            :label="item.shopName"
            :value="item.shopId"
        >
        </el-option>
      </el-select>
      <el-button type="primary" size="small" @click="search">查询</el-button>
      <el-button
          type="success"
          size="small"
          @click="output"
          :loading="isOutputing"
      >导出全部明细</el-button
      >
    </div>
    <div class="table">
      <el-table
        stripe
        border
        :data="list"
        style="width: 100%"
        id="table"
        ref="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="(index) => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <!-- <el-table-column header-align="center" prop="orderOfflineId" align="center" label="线下订单号">
        </el-table-column>-->
        <el-table-column
          header-align="center"
          prop="receiptSn"
          align="center"
          label="订单号"
        ></el-table-column>
        <el-table-column
          header-align="center"
          prop="payTime"
          align="center"
          label="订单销售时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          prop="sendTime"
          align="center"
          label="订单发货时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          prop="shopName"
          align="center"
          label="发货门店"
        ></el-table-column>
        <el-table-column
          header-align="center"
          prop="totalPrice"
          align="center"
          label="订单总额"
        >
          <template slot-scope="scope">
            <span class="primary">￥{{ scope.row.totalPrice }}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          prop="memberName"
          align="center"
          label="会员姓名"
        ></el-table-column>
        <el-table-column
          header-align="center"
          prop="memberMobile"
          align="center"
          label="会员电话"
        ></el-table-column>
        <el-table-column
          header-align="center"
          prop="writePosFailReason"
          align="center"
          label="写入失败原因"
        >
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.writePosFailReason" placement="left">
            <span class="text-overflow">{{
              scope.row.writePosFailReason
            }}</span>
          </el-tooltip>
        </template>
        </el-table-column>
        <!-- <el-table-column
          header-align="center"
          prop="writePosHandleState"
          align="center"
          label="写入Pos处理状态"
        ></el-table-column> -->
        <el-table-column
          header-align="center"
          prop="writePosSuccess"
          align="center"
          label="写入Pos结果"
        >
        <template slot-scope="scope">
          <span v-if="scope.row.writePosSuccess==='normalError'">正常错误</span>
          <span v-else-if="scope.row.writePosSuccess==='error'">错误</span>
          <span v-else-if="scope.row.writePosSuccess==='yes'">是</span>
          <span v-else-if="scope.row.writePosSuccess==='no'">否</span>
          <span v-else-if="scope.row.writePosSuccess==='writing'">写入中</span>
          <span v-else-if="scope.row.writePosSuccess==='refund_success'">退单成功</span>
          <span v-else-if="scope.row.writePosSuccess==='refund_error'">退单失败</span>
          <span v-else-if="scope.row.writePosSuccess==='partialSuccess'">部分成功</span>
          <span v-else>{{scope.row.writePosSuccess}}</span>
        </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="操作"
          v-if="searchConditions.querySnType === 'wait'"
        >
          <template slot-scope="scope">
            <div v-if="!isOperate">
              <el-button @click="details(scope.row)" size="small" type="text"
                >查看</el-button
              >
              <el-divider direction="vertical"></el-divider>
              <el-button @click="write(scope.row)" size="small" type="text"
                >补写</el-button
              >
            </div>
            <div v-else>
              <el-button @click="operate(scope.row)" size="small" type="text"
                >操作</el-button
              >
            </div>
          </template>
          <!-- <template slot-scope="scope" v-else>
            <div>
              <el-button @click="operate(scope.row)" size="small" type="text"
                >操作</el-button
              >
            </div>
          </template> -->
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          :page-size="pageSize"
          layout="total,sizes,  prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="800px"
      :title="title"
    >
      <div class="info">
        <div class="title">商品信息</div>
        <el-table
          stripe
          border
          :data="goodslist"
          style="width: 100%"
          id="table"
          size="small"
        >
          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            header-align="center"
            prop="spuName"
            align="center"
            label="商品名称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            prop="realPrice"
            align="center"
            label="价格"
          ></el-table-column>
          <el-table-column
            header-align="center"
            prop="goodsSn"
            align="center"
            label="货号"
          ></el-table-column>
          <el-table-column
            header-align="center"
            prop="goodsNum"
            align="center"
            label="数量"
          ></el-table-column>
          <el-table-column
            header-align="center"
            prop="actuallyPrice"
            align="center"
            label="实付金额"
          ></el-table-column>
          <el-table-column
            header-align="center"
            prop="receiptSn"
            align="center"
            label="是否实物商品"
          >
            <template slot-scope="scope">
              {{ scope.row.spuType === "virtual" ? "虚拟" : "实物" }}
            </template>
          </el-table-column>
        </el-table>
        <div class="title mt20">异常原因</div>
        <div class="ml10 primary font-style">
          {{ row.writePosFailReason }}
        </div>
        <div class="title mt20">处理建议</div>
        <div class="ml10 primary font-style">
          1.请确认修正ERP中商品的货号信息，联系客服进行整单重写 <br />
          2.或者直接忽略商品，操作页面内补写按钮，将剩余商品进行补写。注意，补写订单为部分商品，找不到的商品信息将被直接忽略，相应的金额以写入的商品金额为准。
        </div>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button size="small" type="info" @click="hulue"
          >忽略本单，无须写入</el-button
        >
        <el-button type="primary" size="small" @click="writeOrder('do')"
          >补写订单</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
        :close-on-click-modal="false"
        :visible.sync="reWriteGoodsSnDialog"
        width="800px"
        :title="title"
    >
      <div class="info">
        <div class="title">商品信息</div>
        <el-table
            :data="v.orderList"
            style="width: 100%; margin-bottom: 20px"
            v-for="(v, i) in multiGoodslist"
            :key="i"
            :span-method="objectSpanMethod"
        >
          <el-table-column
              prop="deliverSn"
              label="发货单号"
              sortable
              width="200"
          >
          </el-table-column>
          <el-table-column prop="receiptSn" label="订单号" sortable width="180">
          </el-table-column>
          <el-table-column
              prop="goodsName"
              label="商品名称"
              sortable
              width="180"
          >
          </el-table-column>
          <el-table-column prop="goodsSn" label="货号" sortable width="180">
          </el-table-column>
          <el-table-column prop="barCode" label="条码" sortable width="180">
          </el-table-column>
          <el-table-column prop="goodsNum" label="数量" sortable width="180">
          </el-table-column>
          <el-table-column
              prop="payMoney"
              label="实付金额"
              sortable
              width="180"
          >
          </el-table-column>
          <el-table-column label="新货号" sortable width="180">
            <template slot-scope="scope">
              <el-input
                  clearable
                  v-model.trim="scope.row.newGoodsSn"
                  placeholder="请输入新货号"
                  size="small"
                  class="ipt mr10"
              ></el-input>
              <!-- {{ scope.row.printNum }} -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button type="primary" size="small" @click="reWriteGoodsSn(multiGoodslist)"
        >确定</el-button
        >
      </span>
    </el-dialog>
    <!-- 操作表格弹窗 -->
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="multiDialogVisible"
      width="800px"
      :title="title"
    >
      <div class="info">
        <div class="title">商品信息</div>
        <el-table
          :data="v.orderList"
          style="width: 100%; margin-bottom: 20px"
          v-for="(v, i) in multiGoodslist"
          :key="i"
          :span-method="objectSpanMethod"
        >
          <el-table-column
            prop="deliverSn"
            label="发货单号"
            sortable
            width="200"
          >
          </el-table-column>
          <el-table-column prop="receiptSn" label="订单号" sortable width="180">
          </el-table-column>
          <el-table-column
            prop="goodsName"
            label="商品名称"
            sortable
            width="180"
          >
          </el-table-column>
          <el-table-column prop="goodsSn" label="货号" sortable width="180">
          </el-table-column>
          <el-table-column prop="barCode" label="条码" sortable width="180">
          </el-table-column>
          <el-table-column prop="goodsNum" label="数量" sortable width="180">
          </el-table-column>
          <el-table-column
            prop="payMoney"
            label="实付金额"
            sortable
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="isReality"
            label="是否实物商品"
            sortable
            width="180"
          >
            <template slot-scope="scope">
              {{ scope.row.isReality == true ? "实物" : "虚拟" }}
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            prop="writePosFailReason"
            label="异常原因"
            sortable
            width="180"
          >
          </el-table-column>
          <el-table-column fixed="right" prop="payMoney" label="操作" sortable width="180">
            <template slot-scope="scope">
              <div>
                <el-button @click="write(scope.row)" size="small" type="text"
                  >补写</el-button
                >
                <el-button @click="preReWriteGoodsSn(scope.row)" size="small" type="text"
                >修改货号补写</el-button
                >
                <el-divider direction="vertical"></el-divider>
                <el-button @click="hulue(scope.row)" size="small" type="text"
                  >忽略</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="title mt20">处理建议</div>
        <div class="ml10 primary font-style">
          1.请确认修正ERP中商品的货号信息，联系客服进行整单重写 <br />
          2.或者直接忽略商品，操作页面内补写按钮，将剩余商品进行补写。注意，补写订单为部分商品，找不到的商品信息将被直接忽略，相应的金额以写入的商品金额为准。
        </div>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <!-- <el-button size="small" type="info" @click="hulue"
          >忽略本单，无须写入</el-button
        >
        <el-button type="primary" size="small" @click="writeOrder('do')"
          >补写订单</el-button
        > -->
        <el-button type="primary" size="small" @click="multiDialogVisible = false"
          >确定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleWrite"
      width="1000px"
      :title="title"
    >
      <div>
        <el-table
          stripe
          border
          :data="goodslist"
          style="width: 100%"
          id="table"
          size="small"
        >
          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            header-align="center"
            prop="spuName"
            align="center"
            label="商品名称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            prop="realPrice"
            align="center"
            label="价格"
          ></el-table-column>
          <el-table-column
            header-align="center"
            prop="goodsSn"
            align="center"
            label="货号"
          ></el-table-column>
          <el-table-column
            header-align="center"
            prop="goodsNum"
            align="center"
            label="数量"
          ></el-table-column>
          <el-table-column
            header-align="center"
            prop="actuallyPrice"
            align="center"
            label="实付金额"
          ></el-table-column>
          <el-table-column
            header-align="center"
            prop="receiptSn"
            align="center"
            label="是否实物商品"
          >
            <template slot-scope="scope">
              {{ scope.row.spuType === "virtual" ? "虚拟" : "实物" }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button size="small" type="info">确认补写</el-button>
        <el-button
          type="primary"
          size="small"
          @click="dialogVisibleWrite = false"
          >关闭</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleSuccess"
      width="800px"
      title="补写订单成功"
    >
      <div class="ml10 primary font-style">
        {{ successRow }}
      </div>
    </el-dialog>
    <el-dialog
        custom-class="import-dialog"
        :title="writeTitle"
        :visible="showWriteDialog"
        width="800px"
        @close="closeWriteDialog"
    >
      <el-steps :active="1" simple>
        <el-step title="下载数据模板" icon="hmicon icon-yi"></el-step>
        <el-step title="导入数据" icon="hmicon icon-ziyuan"></el-step>
      </el-steps>
      <div class="import-dialog-body">
        <div class="mb20">
          <div class="title">下载数据模板</div>
          <div class="tips">必须严格按照模板内容填写，否则可能会出现导入异常</div>
          <div class="tips">不要随意增删表格字段，以免出现导入异常</div>
        </div>
        <div class="mb20">
          <el-button
              @click="outPutTemp"
              type="primary"
              size="small"
              icon="hmicon icon-xls"
          >模板下载</el-button
          >
        </div>
         <div v-if="writeType === 'order'" class="mb20">
          <div class="title">请选择导入类型</div>
          <el-radio-group v-model="importWriteType" size="small">
            <el-radio-button label="order">默认导入</el-radio-button>
            <el-radio-button label="ignoreGuiderAndShop">忽略手机号+门店</el-radio-button>
            <el-radio-button label="ignoreShop">忽略门店</el-radio-button>
            <el-radio-button label="ignoreGuiderPhone">忽略手机号</el-radio-button>
          </el-radio-group>
        </div>
        <div>
          <div class="title">导入订单</div>
          <div class="flex" ref="select_frame">
            <div class="import-btn open-file">
              <div class="add-wrapper">
                <span class="hmicon icon-hao pointer"></span>
              </div>
              <span>点击导入</span>
              <input
                  type="file"
                  @change="importf"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              />
            </div>

          </div>
        </div>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import { getLoginUser } from "@/utils/auth";
import {arrayUnique2} from "@/utils/utils";
import XLSX from "xlsx";

let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: {},
  data() {
    return {
      successRow: "",
      dialogVisibleSuccess: false,
      dialogVisibleWrite: false,
      goodslist: [],
      title: "",
      dialogVisible: false,
      currentPage: 1,
      pageSize: 10,
      list: [],
      total: 0,
      searchConditions: {
        querySnType: "wait",
        date: [],
      },
      row: {},
      // 是否显示操作
      isOperate: false,
      multiGoodslist: [], // 合并单元格表格数据
      multiDialogVisible: false, // 操作表格弹窗
      reWriteGoodsSnDialog: false,//修改货号补写弹窗
      shopList: [],
      isOutputing: false,
      showWriteDialog: false, //显示异常订单写入弹框
      writeTitle: "",
      writeType: "",
      importWriteType: "", // 导入方式类型
      storeCode: "",
    };
  },
  computed: {},
  watch: {},
  created() {
    let user = getLoginUser();
    this.storeCode = user.storeCode;
    console.log(this.storeCode);
  },
  mounted() {
    this.queryList();
    this.operateShow();
    this.queryShopList();
  },
  methods: {
    async queryShopList() {
      const {code, result} = await this.$store.dispatch("queryShopList", {
        pageNo: 1,
        pageSize: 1000
      });
      if (code === '0') {
          this.shopList = result.records;
      }
    },
    operateShow() {
      // 只有昆明（53010017032439）和禾苗（42010216070190）的渠道才是相应的操作，其他渠道保持原有逻辑不变
      if (this.storeCode == "42010216070190" || this.storeCode == "53010017032439" || this.storeCode == "50010311207654") {
        this.isOperate = true;
      }
    },
    hulue(row) {
      this.writeOrder("ignore",row);
    },
    async writeOrder(writePosHandleState,row) {
      let params = {
        orderId: this.row.orderId,
        receiptSn:
          writePosHandleState === "ignore"
            ? this.row.receiptSn
            : "BX" + this.row.receiptSn,
        writePosHandleState,
      };
      if (this.isOperate) {
        console.log('scope row')
        console.log(row)
        params.deliverSn = row.deliverSn;
        console.log(row.deliverSn);
        params.type = writePosHandleState;
        var { code, result } = await this.$store.dispatch(
          "mopOrderPushErrorHandle",
          params
        );
      } else {
        var { code, result } = await this.$store.dispatch(
          "queryOrderPushErrorHandle",
          params
        );
      }
      if (code === "0") {
        this.$message({
          message: "操作成功！",
          type: "success",
        });
        if (writePosHandleState === "do" && result) {
          this.dialogVisibleSuccess = true;
          this.successRow = result;
        }
        this.dialogVisibleWrite = false;
        this.dialogVisible = false;
        this.queryList();
      }
      if (this.isOperate) {
        this.operate(this.row)
      }
    },
    write(row) {
      this.row = row;
      this.writeOrder("do",row);
    },
    async details(row) {
      this.row = row;
      const { code, result } = await this.$store.dispatch(
        "queryOrderPushErrorDetail",
        {
          receiptSn: row.receiptSn,
        }
      );
      if (code === "0") {
        this.title = "订单详情";
        this.goodslist = result;
        this.dialogVisible = true;
      }
    },
    // 操作
    async operate(row) {
      this.row = row;
      // 异常订单列表（当商城为登康贝比的时候），页面重做（增加操作按钮，通过操作按钮点开）
      // https://e.gitee.com/hemiao100/issues/kanban?issue=I4IV6W
      const { code, result } = await this.$store.dispatch(
        "mopOrderPushErrorDetail",
        {
          receiptSn: row.receiptSn,
        }
      );
      if (code === "0") {
        this.title = "订单详情";
        this.multiGoodslist = result;
        this.multiDialogVisible = true;
        this.multiGoodslist.forEach((v) => {
          v.orderList.forEach((x, xIdx) => {
            x.receiptSn = v.receiptSn;
            x.deliverSn = v.deliverSn;
            try {
              x.writePosFailReason = typeof v.writePosFailReason == "object" ? v.writePosFailReason : JSON.parse(v.writePosFailReason).ResultString;
            } catch (error) {
              x.writePosFailReason = v.writePosFailReason
            }
            if (xIdx == 0) {
              x.rowspan = v.orderList.length;
            }
          });
        });
        console.log("this.multiGoodslist:", this.multiGoodslist);
      }
    },
    preReWriteGoodsSn(row) {
      this.title = "修改订单货号补写";
      this.reWriteGoodsSnDialog = true;
    },

    async reWriteGoodsSn(row) {
      let param = null;
      row.filter( v =>{
          param = v;
        }
      );
      var { code, result } = await this.$store.dispatch(
          "reWriteGoodsSn", param
      );
      if (code === "0") {
        this.$message({
          message: "操作成功！",
          type: "success",
        });
        if (writePosHandleState === "do" && result) {
          this.dialogVisibleSuccess = true;
          this.successRow = result;
        }
        this.dialogVisibleWrite = false;
        this.dialogVisible = false;
        this.queryList();
      }
      this.reWriteGoodsSnDialog = false;

    },
    // 合并单元格
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (
        columnIndex === 0 ||
        columnIndex === 1 ||
        columnIndex == 8 ||
        columnIndex == 9
      ) {
        return {
          rowspan: row.rowspan,
          colspan: 1,
        };
      }
    },
    switchTab() {
      this.currentPage = 1;
      this.queryList().then(() => {
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          //给table加一个ref
        });
      });
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    async queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchConditions));
      searchCondition.queryTimeValueStart = this.isArray(searchCondition.date)
        ? searchCondition.date[0]
        : "";
      searchCondition.queryTimeValueEnd = this.isArray(searchCondition.date)
        ? searchCondition.date[1]
        : "";

      Object.assign(params, searchCondition);

      const { result } = await this.$store.dispatch(
        "queryOrderPushErrorList",
        params
      );
      const { records, total } = result;
      this.list = records;
      this.total = total;
    },
    async output() {
      this.isOutputing = true;
      const searchCondition = JSON.parse(JSON.stringify(this.searchConditions));
      searchCondition.exportName = "异常订单列表导出";
      this.$store.dispatch("export", searchCondition);
      setTimeout(() => {
        this.$message({
          message: "已加入导出队列正在生成报表，请在导出列队中查看！",
          type: "success"
        });
        this.hidden = false;
        this.drawer = false;
      }, 0);
    },
    writeDialog(type) {
      this.showWriteDialog = true;
      this.writeType = type;
      // 如果是批量写入订单，默认选择订单号导入方式
      if (type === 'order') {
        this.importWriteType = 'order';
      } else {
        this.importWriteType = type;
      }
      switch (type) {
        case "order":
          this.writeTitle = "批量写入订单到MOP";
          break;
        case "updateGoodsSn":
          this.writeTitle = "批量修改订单货号写入MOP";
          break;
        case "updateShopId":
          this.writeTitle = "批量修改订单门店写入MOP"
          break;
        case "ignore":
          this.writeTitle = "批量忽略订单"
          break;
      }
      console.log(type);
    },
    outPutTemp() {
      console.log(this.writeType)
      if (this.writeType === 'order' || this.writeType === 'ignore') {
        require.ensure([], () => {
          const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
          const tHeader = [
            "订单号"
          ];
          const data = [
            ["ABC123"],
          ];

          exportJsonToExcel(tHeader, data, "异常订单模板");
        });
      } else if (this.writeType === 'updateGoodsSn') {
        require.ensure([], () => {
          const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
          const tHeader = [
            "订单号", "新商品货号"
          ];
          const data = [
            ["ABC123", "123"],
          ];

          exportJsonToExcel(tHeader, data, "异常订单货号修改模板");
        });
      } else if (this.writeType === 'updateShopId') {
        require.ensure([], () => {
          const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
          const tHeader = [
            "订单号", "新门店名称"
          ];
          const data = [
            ["ABC123", "123"],
          ];

          exportJsonToExcel(tHeader, data, "异常订单门店修改模板");
        });
      }
    },
    importf(e) {
      // 使用 importWriteType 作为实际的导入类型
      const importType = this.writeType === 'order' ? this.importWriteType : this.writeType;
      console.log(importType);
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        let result = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        let orders = [];
        result.forEach(v => {
          v[0] = v[0] ? (v[0] + "").replace(/\s*/g, "") : "";
          if (v[0] !== "") {
            if (importType === 'order' || importType === 'ignore' || importType === 'ignoreGuiderAndShop' || importType === 'ignoreShop' || importType === 'ignoreGuiderPhone') {
              orders.push({
                receiptSn: v[0]
              });
            } else if (importType === 'updateGoodsSn') {
              orders.push({
                receiptSn: v[0],
                goodsSn: v[1],
              });
            } else if (importType === 'updateShopId') {
              orders.push({
                receiptSn: v[0],
                shopName: v[1],
              });
            }
          }
        });
        orders = arrayUnique2(orders, "receiptSn");
        let param = {
          orders: orders,
          writeType: importType
        }
        that.$store.dispatch("batchWriteOrder", param)
            .then(res => {
              that.$message({
                message: "请求已发送，结果稍后请在异常订单列表中查看!",
                type: "success"
              });
              that.closeWriteDialog();
              that.search()
            });
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    closeWriteDialog() {
      this.showWriteDialog = false;
      this.importWriteType = "";
    },
  },
};
</script>
<style lang="scss" scoped>
.import-dialog-body {
  padding: 40px 20px;
}
.info {
  .title {
    margin-bottom: 10px;
    &::before {
      display: inline-block;
      margin-right: 10px;
      content: "";
      width: 4px;
      height: 12px;
      background: #e50065;
      border-top-left-radius: 30px;
      border-bottom-right-radius: 30px;
    }
  }
}
.font-style {
  font-weight: bold;
  font-size: 18px;
  line-height: 25px;
}
</style>
